var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1665 2.0835C30.1665 1.25507 29.4949 0.583496 28.6665 0.583496C27.8381 0.583496 27.1665 1.25507 27.1665 2.0835V4.6665H13.8335V2.0835C13.8335 1.25507 13.1619 0.583496 12.3335 0.583496C11.5051 0.583496 10.8335 1.25507 10.8335 2.0835V4.6665H4.125C2.192 4.6665 0.625 6.23351 0.625 8.1665V18.4165V40.9165C0.625 42.8495 2.192 44.4165 4.125 44.4165H36.875C38.808 44.4165 40.375 42.8495 40.375 40.9165V18.4165V8.1665C40.375 6.23351 38.808 4.6665 36.875 4.6665H30.1665V2.0835ZM37.375 16.9165V8.1665C37.375 7.89036 37.1511 7.6665 36.875 7.6665H30.1665V10.2502C30.1665 11.0786 29.4949 11.7502 28.6665 11.7502C27.8381 11.7502 27.1665 11.0786 27.1665 10.2502V7.6665H13.8335V10.2502C13.8335 11.0786 13.1619 11.7502 12.3335 11.7502C11.5051 11.7502 10.8335 11.0786 10.8335 10.2502V7.6665H4.125C3.84886 7.6665 3.625 7.89036 3.625 8.1665V16.9165H37.375ZM3.625 19.9165H37.375V40.9165C37.375 41.1926 37.1511 41.4165 36.875 41.4165H4.125C3.84886 41.4165 3.625 41.1926 3.625 40.9165V19.9165Z",
    fill: "url(#paint0_linear_1_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3064 25.2797C26.7042 24.8966 27.3372 24.9085 27.7203 25.3064C28.1034 25.7042 28.0915 26.3372 27.6936 26.7203L19.386 34.7203C18.9987 35.0932 18.3859 35.0932 17.9987 34.7203L14.3064 31.1648C13.9085 30.7817 13.8966 30.1486 14.2797 29.7508C14.6628 29.353 15.2958 29.341 15.6936 29.7241L18.6923 32.6117L26.3064 25.2797Z",
    fill: "url(#paint1_linear_1_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_11",
    x1: 0.625,
    y1: 44.4165,
    x2: 49.4934,
    y2: 27.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#E23B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998652,
    stopColor: "#AE04FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998752,
    stopColor: "#AE04FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_11",
    x1: 14,
    y1: 35,
    x2: 28.9003,
    y2: 26.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#E23B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998652,
    stopColor: "#AE04FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998752,
    stopColor: "#AE04FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGradient);
export default __webpack_public_path__ + "static/media/calendar-gradient.8854192b.svg";
export { ForwardRef as ReactComponent };